module.exports = __webpack_public_path__ + "img/department_icon5.151359bb.png";